// components/Users/VerifyEmail/VerifyEmailModal.jsx
import React, { useEffect, useRef, useState } from "react";
import Button from "../../../Elements/Button/Button";
import Input from "../../../Elements/Input/Input";

const formatSecs = (msLeft) => `${Math.max(0, Math.ceil(msLeft / 1000))}s`;

const VerifyEmailModal = ({
  email,
  open,
  onClose,
  onVerified,               // el padre lo usa para redirigir
  onResend,                 // () => void
  onVerify,                 // (otp) => Promise|void
  otpSending = false,
  otpVerifying = false,
  otpError = null,
  otpSuccess = null,
  otpCooldownUntil = null,
}) => {
  const [otp, setOtp] = useState("");
  const inputRef = useRef(null);

  // limpia al cerrar
  useEffect(() => {
    if (!open) setOtp("");
  }, [open]);

  // countdown
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!open) return;
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, [open]);
  const now = Date.now();
  const msLeft = Math.max(0, (otpCooldownUntil || 0) - now);
  const canResend = !otpCooldownUntil || msLeft <= 0;

  // onChange tolerante a evento/valor
  const handleOtpChange = (evOrVal) => {
    const raw =
      typeof evOrVal === "string"
        ? evOrVal
        : typeof evOrVal?.target?.value === "string"
        ? evOrVal.target.value
        : "";
    setOtp(raw.replace(/\D/g, "").slice(0, 6));
  };

  const handleKeyDown = (e) => {
    if (e?.key === "Enter" && otp.length === 6 && !otpVerifying) {
      onVerify?.(otp);
    }
  };

  // ¿mostrar “éxito verificado” en el modal?
  const verified = !!otpSuccess && /verificad/i.test(String(otpSuccess));

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 otp-modal__overlay">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 otp-modal__card" role="dialog" aria-modal="true">
        <h3 className="otp-modal__title">Verifica tu correo</h3>
        <p className="otp-modal__desc">
          Te enviamos un código a <b>{email}</b>.
        </p>

        {verified ? (
          <>
            <div className="otp-success">
              <div className="otp-success__icon">✅</div>
              <div className="otp-success__text">¡Correo verificado!</div>
              {typeof otpSuccess === "string" && <div className="text-sm">{otpSuccess}</div>}
            </div>
            <div className="otp-footer">
              <Button text="Continuar" color="blue" fill action={onVerified || onClose} />
            </div>
          </>
        ) : (
          <>
            <Input
              ref={inputRef}
              value={otp}
              onChange={handleOtpChange}
              onKeyDown={handleKeyDown}
              label="Código de 6 dígitos"
              inputMode="numeric"
              pattern="\d*"
              maxLength={6}
              autoFocus
            />

            {otpError && <p className="otp-msg otp-msg--error">{otpError}</p>}
            {otpSuccess && !verified && <p className="otp-msg otp-msg--ok">{otpSuccess}</p>}

            <div className="otp-actions">
              <Button
                text={otpVerifying ? "Verificando..." : "Verificar"}
                color="blue"
                fill
                disabled={otpVerifying || otp.length !== 6}
                action={() => onVerify?.(otp)}
              />
              <Button
                text={
                  otpSending
                    ? "Enviando..."
                    : canResend
                    ? "Reenviar código"
                    : `Reenviar en ${formatSecs(msLeft)}`
                }
                color="gray"
                disabled={!canResend || otpSending}
                action={() => onResend?.()}
              />
            </div>

            <div className="otp-footer">
              <Button text="Cerrar" color="gray" action={onClose} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailModal;